
































































































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import PublicLayout from '@/views/layouts/PublicLayout.vue';
import { Enterprise, EnterpriseModel } from '@/resources/enterprise/Enterprise';
import { namespace } from 'vuex-class';
import { NAMESPACE } from '@/store/models/pub/enterprises';
import { NAMESPACE as PRODUCTS_NAMESPACE } from '@/store/models/pub/products';
import { Group, NAMESPACE as GROUP_NAMESPACE } from '@/store/models/pub/products/groups';
import { GET_ITEM, GET_ITEMS, ITEMS_REQUEST, LOADING, SHOW_REQUEST, META } from '@/store';
import Pagination from '@/components/Pagination.vue';
import { Product } from '@/store/types/public/products/Product';
import { PageMeta } from '@/store/types/pagination';
import { Watch } from 'vue-property-decorator';
import ProductItem from '@/components/public/products/Item.vue';

const enterpriseStore = namespace(NAMESPACE);
const productsStore = namespace(PRODUCTS_NAMESPACE);
const groupStore = namespace(GROUP_NAMESPACE);
@Component({
  components: { PublicLayout, Pagination, ProductItem }
})
export default class EnterpriseProductsIndex extends Mixins<SlotMixin>(SlotMixin) {
  @enterpriseStore.Getter(GET_ITEM) enterprise!:Enterprise;
  @enterpriseStore.Getter(LOADING) loading!:boolean;
  @enterpriseStore.Action(SHOW_REQUEST) getEnterprise: any;

  public per_page = 20;
  @Watch('per_page')
  setPerPage () {
    this.updateProducts();
  }

  public filters = {
    present: '1',
    search: '',
    group: ''
  };

  @productsStore.Getter(GET_ITEMS) products!:Product[];
  @productsStore.Getter(LOADING) products_loading!: boolean;
  @productsStore.Getter(META) meta!: PageMeta;
  @productsStore.Action(ITEMS_REQUEST) getProductsRequest: any;

  @groupStore.Action(ITEMS_REQUEST) getGroupsRequest: any;
  @groupStore.Getter(GET_ITEMS) groups!:Group[];

  @Watch('filters', { deep: true })
  public updateFilters () {
    if (this.$route.query.page) {
      this.$route.query.page = '1';
    }
    this.updateProducts();
  }

  @Watch('$route.query')
  public updateProducts () {
    this.getProductsRequest({ per_page: this.per_page, ...this.$route.query, filters: this.filters });
  }

  created () {
    this.getEnterprise(this.$route.params.enterprise);
    this.getGroupsRequest();
    this.updateProducts();
    this.$gtag.event('page_view', { screen_name: 'Перегляд підприємства' });
  }
}
